import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink target="_blank" href="https://www.facebook.com/GOT-PHO-THIEN-KIM-100984015713494/?ref=py_c">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Got Pho Vietnamese Facebook"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/got-pho-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Got Pho Vietnamese Yelp"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/got-pho-thien-kim-vietnamese-restaurant-kensington-vancouver/menu">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Got Pho Vietnamese Zomato"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Got Pho Vietnamese Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink target="_blank" href="https://www.facebook.com/GOT-PHO-THIEN-KIM-100984015713494/?ref=py_c">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Got Pho Vietnamese Facebook"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/got-pho-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Got Pho Vietnamese Yelp"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/got-pho-thien-kim-vietnamese-restaurant-kensington-vancouver/menu">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Got Pho Vietnamese Zomato"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Got Pho Vietnamese Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
